import { mutatorAction } from "satcheljs";
import { shiftEditorViewState } from "..";

export default mutatorAction("updateBusySharing", function updateBusySharing(isSharing: boolean) {
    shiftEditorViewState().busySharing = isSharing;
});